import React, { createContext, useContext, useState } from "react";

import {
  ContractListFilters,
  ContractStatus,
  useContractList,
} from "@/services/ContractsService";
import { useDrawerState } from "@/components/misc/Drawer";
import { useParamState } from "@/services/Routing";

import {
  ContractTab,
  IContractsListPageContext,
} from "./ContractsListPage.types";

const ContractsListPageContext = createContext({} as IContractsListPageContext);

export const useContractsListPage = () => useContext(ContractsListPageContext);

export const ContractsListPageProvider: React.FC<{
  children?: React.ReactNode;
}> = ({ children }) => {
  const [filters, setFilters] = useState<ContractListFilters>({});
  const [activeTab, setActiveTab] = useState(ContractTab.Active);
  const [showAll] = useParamState("all", false);
  const { data: contractList, isLoading: isContractListLoading } =
    useContractList({
      filters: {
        ...filters,
        status:
          activeTab === "Completed" ? ContractStatus.Completed : filters.status,
      },
      onlyJobs: !showAll,
    });

  const [search, setSearch] = useState("");

  const sortPanelState = useDrawerState();
  const filterPanelState = useDrawerState();

  return (
    <ContractsListPageContext.Provider
      value={{
        search,
        setSearch,
        activeTab,
        setActiveTab,
        contractList,
        isContractListLoading,
        sortPanelState,
        filterPanelState,
        filters,
        setFilters,
      }}
    >
      {children}
    </ContractsListPageContext.Provider>
  );
};
